/*ReactJS*/
import React from 'react';

/*Material UI Components*/
import { Typography, Breadcrumbs, Box } from '@material-ui/core';

/*Styles*/
import useStyles from '../../styles';

/*Table Components*/
import MonthlyStatementDisclosureTable from './Components/MonthlyStatementDisclosureTableComponent';

export default function Etf(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.pageContainer}>
        <Box>
          <Typography
            variant="h2"
            className={classes.textBold}
            align="left"
            gutterBottom={true}
          >
            Monthly Statement Disclosure
          </Typography>
          <Breadcrumbs aria-label="breadcrumb">
            <span color="inherit">Report</span>
            <span color="inherit">Report</span>
            <Typography color="primary">
              Monthly Statement Disclosure
            </Typography>
          </Breadcrumbs>
        </Box>
        <Box mt={2}>
          <MonthlyStatementDisclosureTable params={props} />
        </Box>
      </div>
    </React.Fragment>
  );
}
